module.exports = __webpack_public_path__ + "static/2-a6f281326c87eb7be0b2e8b73ca0c2a3.png";